import { createCapHeader, createMeta } from "../../../components/hocs/createCapHeader";

const title = "QA";
export const QaHeader = createCapHeader(title, "/");
export const QaMeta = createMeta(title);
